export const ERP_POPUP_BUTTON_URI_MAP = {
  "Fetch Quotation Popup Data": `/api/rfq/quotation-popup-data`,
  "Submit Price Request": `/api/rfq/submit-quotation`,
} as const;

export type ErpPopupAction = keyof typeof ERP_POPUP_BUTTON_URI_MAP;

export function getErpPopupUri(
  action: ErpPopupAction,
  baseUrl: string,
): string {
  const apiBaseUrl =
    (typeof process !== "undefined" &&
      process.env?.NEXT_PUBLIC_ERP_API_BASE_URL) ||
    baseUrl;
  return `${apiBaseUrl}${ERP_POPUP_BUTTON_URI_MAP[action]}`;
}

export function getErpPopupUriByButtonLabel(
  label: string,
  baseUrl: string,
): string | null {
  if (!label) return null;
  const apiBaseUrl =
    (typeof process !== "undefined" &&
      process.env?.NEXT_PUBLIC_ERP_API_BASE_URL) ||
    baseUrl;
  return (
    `${apiBaseUrl}${ERP_POPUP_BUTTON_URI_MAP[label as ErpPopupAction] ?? ""}` ||
    null
  );
}
